/**
 * Format items for a description. There can sometimes be too many words to list so only some are listed and the rest
 * are hidden behind a "and 2 more" type description.
 * @param anomalyEvents All events that have happened in an anomaly.
 * @returns             Phrases to list, and details of how to abbreviate the list.
 */
export const formatItems = (items: string[], maximumItems: number) => {
    const itemCount = items.length;

    // There is no point in ever showing "1 more" rather than just the item itself, so the display will only ever be
    // shortened if there are at least two more than the maximum allowed.
    const excessPhrases = itemCount - maximumItems === 1 ? 2 : itemCount - maximumItems;
    const isAbbreviated = excessPhrases > 0;
    const listedPhrases = isAbbreviated ? items.slice(0, itemCount - excessPhrases) : items;

    return { excessPhrases, listedPhrases, isAbbreviated };
};
